import React from 'react'
import MainLayout from '@layouts/main-layout'
import FAQ from '@components/footer/faq'

const FAQPage = () => {
  return (
    <>
      <FAQ />
    </>
  )
}

FAQPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default FAQPage
